import { Component, inject } from '@angular/core';
import { DialogRef } from '@core/shared/utils/dialog/dialog-ref';
import { ButtonComponent } from '@core/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-business-account-dialog',
  standalone: true,
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './business-account-dialog.component.html',
  styleUrl: './business-account-dialog.component.scss',
})
export class BusinessAccountDialogComponent {
  // dependencies
  private readonly _dialogRef = inject(DialogRef);
  constructor() {}

  public close() {
    this._dialogRef.close();
  }
  public confirm() {
    this._dialogRef.close(true);
  }
}
